import { useQuery } from "react-query";
import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import type { FieldTypes } from "@circle-react-shared/ProfileFields/constants";
import { useIsProfileFieldsEnabled } from "@circle-react-shared/ProfileFields/useIsProfileFieldsEnabled";

export const SEARCHABLE_PROFILE_FIELDS_LIST_KEY = "searchable-profile-fields";

interface ProfileField {
  field_type: FieldTypes;
  id: number;
  label: string;
}

export const useProfileFieldsList = () => {
  const isProfileFieldsEnabled = useIsProfileFieldsEnabled();

  const getOptions = useQuery<ProfileField[], unknown>(
    [SEARCHABLE_PROFILE_FIELDS_LIST_KEY],
    async () => reactQueryGet(internalApi.profileFields.searchableList()),
    {
      enabled: !!isProfileFieldsEnabled,
    },
  );

  return {
    getOptions,
  };
};
